import * as ActionTypes from '~/actions/ActionTypes'

export const setActiveProjectError = (type, message) => async dispatch => {
  await dispatch({ type: ActionTypes.PROJECTS_ACTIVE_PROJECT_ERROR, payload: { type, message } })
}
